//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { Component } from '@angular/core';
import { DialogService } from '@app/core/services/dialog-service.service';
import { Helper } from '@rawlings/core';
import { OnInit } from '@angular/core';
import { PHONE_NUMBER } from '@app/member-response-portal/model/constants';
//#endregion Imports
@Component({
    selector: 'app-failed-request-component',
    templateUrl: './failed-request.component.html',
    styleUrls: ['./failed-request.component.scss']
})
export class FailedRequestComponent implements OnInit {
    //#region Public Variables
    public PhoneNumber: string;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(
        private dialogService: DialogService,
        private authenticationService: AuthenticationService,
    ) {}
    public ngOnInit(): void {
        const cachePolicy : string = localStorage.getItem(PHONE_NUMBER);

        if (!Helper.IsEmpty(cachePolicy)){
            this.PhoneNumber = cachePolicy;
        }
    }
    //#endregion Constructor

    //#region Public Methods
    public OnClickRedirectToLogin(): void {
        this.authenticationService.LogoutAndRedirectToLogin();
        this.dialogService.CloseDialog();
    }
    //#endregion Public Methods
}
